import { acceptedLangs } from './models';
import type { AcceptedLang } from './models';

export const isAcceptedLang = (s: string): s is AcceptedLang => {
    return acceptedLangs.includes(s as AcceptedLang);
};
